import React from 'react';
import { PageDefinition } from '../../createRoutes';
import Page from '../../layouts/Page';
import Content from './Content';

export const dailyPage: PageDefinition = {
    path: '/daily',
    Component() {
        return (
            <Page breadcrumbs={{ name: 'Daily orders' }}>
                <Content />
            </Page>
        );
    },
};
